/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
	'project-pages.connect-space-dialog.connection-error': 'Pripojenie zlyhalo.',
	'project-pages.connect-space-dialog.connection-retry': 'Opakovať',
	'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
		'Pred vytvorením stránky je nutné prepojiť tento projekt s priestorom. Vyberte priestor, ktorý s týmto projektom chcete prepojiť.',
	'project-pages.connect-space-dialog.error-icon': 'Chyba:',
	'project-pages.connect-space-dialog.footer.cancel': 'Zrušiť',
	'project-pages.connect-space-dialog.footer.connect-space': 'Pripojiť',
	'project-pages.connect-space.description':
		'Priestory sú ako priečinky. Môžete ich používať na vytváranie obsahu súvisiaceho s vaším projektom, jeho organizovanie alebo spoluprácu na ňom.',
	'project-pages.create-space-dialog.connection-error': 'Pripojenie zlyhalo.',
	'project-pages.create-space-dialog.connection-retry': 'Opakovať',
	'project-pages.create-space-dialog.content.empty-name': 'Pomenujte svoj priestor.',
	'project-pages.create-space-dialog.content.invalid-name':
		'Názvy priestorov musia obsahovať aspoň jedno písmeno alebo číslicu.',
	'project-pages.create-space-dialog.content.placeholder': 'Zadajte názov priestoru',
	'project-pages.create-space-dialog.creation-error': 'Vytvorenie priestoru sa nepodarilo.',
	'project-pages.create-space-dialog.error-icon': 'Chyba:',
	'project-pages.create-space-dialog.footer.cancel': 'Zrušiť',
	'project-pages.create-space-dialog.footer.create-space': 'Vytvoriť',
	'project-pages.create-space-dialog.header.title': 'Vytvoriť nový priestor Confluence',
	'project-pages.default-contextual-message':
		'Vytvárajte dokumenty k projektu, zdieľajte ich a spolupracujte na nich na jednom mieste so stránkami Confluence.',
	'project-pages.default-reactivate-CTA': 'Znovu aktivovať Confluence',
	'project-pages.default-trial-CTA': 'Vyskúšajte si aplikáciu Confluence bezplatne na 30 dní',
	'project-pages.generic-error.button.reload': 'Znova načítajte stránku',
	'project-pages.generic-error.description': 'Niečo sa pokazilo. Skúste to znova neskôr.',
	'project-pages.generic-error.heading': 'Ejha, toto je trápne...',
};
